export { default as StudentEdit } from './StudentEdit';

